import React, { useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import styled from 'styled-components';
const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #292a2a;
  background-color: rgb(240, 255, 240);
  background: #ffffff;
`;

export const Step = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  color: #000;
  margin-right: ${({ active }) => (active ? '5px' : '0')};
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const Label = styled.span`
  font-weight: 500;
`;
const HoverUnderlineLabel = styled(Label)`
  color: #0000ee;
  cursor: pointer;
  padding: 2px;
  border-radius: 2px;
  &:hover {
    text-decoration: underline;
  }
`;
const DrillThroughFilterMenu = (props) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Container>
      <Step onMouseEnter={() => setHovered(true)} active>
        <Label style={{ minWidth: '100px' }}>Drill Through</Label>
      </Step>

      {hovered && (
        <Step
          style={{ marginLeft: '0px' }}
          onClick={() => props?.handleDrillThrough()}
        >
          <ArrowForwardIosIcon fontSize='small' />
          &nbsp;
          <HoverUnderlineLabel style={{ color: ' #0000EE' }}>
            Posts
          </HoverUnderlineLabel>
        </Step>
      )}
    </Container>
  );
};

export default DrillThroughFilterMenu;
